import * as React from "react";
import { ReactComponent as Arrow } from "../img/Mouse-Arrow.svg";
import "./ScrollIcon.scss"

export const ScrollIcon: React.FunctionComponent = (props) => {
  return <div className='icon-scroll'>
    <Arrow className="down-arrow" />
  </div>;
};
